import React, { useCallback, useEffect, useState } from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import './ResultRelayDetails.scss';
import {
    Column,
    DataGrid,
    Editing,
    Lookup
} from 'devextreme-react/data-grid';
import { checkPermission } from '../../../permissions.js';
import { EditCellTimeComponent, TimeBoxBold } from '../../utils/time-box/TimeBox.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getApiToken } from '../../../utils/authUtils.js';
import { PerformanceCellOnlyIncrease } from '../../utils/performance-cell/PerformanceCell.js';
import { useMsal } from "@azure/msal-react";
export const ResultRelayDetails = (props) => {
    const { instance, accounts } = useMsal();
    const [resultRankStore, setresultRankStore] = useState(null);
    const [resultSplitsStore, setresultSplitsStore] = useState(null);
    const [athleteStore, setathleteStore] = useState(null);
    useEffect(() => {
        if (props.data.key) {
            getApiToken(instance, accounts).then((token) => {

                setresultRankStore({
                    store: createStore({
                        key: 'resultRelayRanksId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/RanksRelay`,
                        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/InsertRelaySplit`,
                        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/UpdateRelaySplit`,
                        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/DeleteRelaySplit`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: ['relayId', '=', props.data.data.relayId]
                });
                setresultSplitsStore({
                    store: createStore({
                        key: 'splitRelayId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Split/SplitsRelayView`,
                        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Split/InsertRelaySplit`,
                        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Split/UpdateRelaySplit`,
                        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Split/DeleteRelaySplit`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: ['relayId', '=', props.data.data.relayId]
                });
                setathleteStore({
                    store: createStore({
                        key: 'athleteId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/AthletesBasic`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
   filter: ['clubId', '=', props.data.data.clubId]
                });
            })
        }
    }, [props.data.key]);


    return (
        <div className='panelrelaydetails'>
            <div className='left'>
                <DataGrid dataSource={resultSplitsStore} showBorders={true} remoteOperations={true}>
                    <Editing allowUpdating={checkPermission("result.edit")} allowAdding={false} allowDeleting={checkPermission("result.edit")} />
                    <Column dataField="distance" caption='Distanz' dataType='number' hidingPriority={2} />
                    <Column dataField="swimtime" caption='Zeit' sortIndex={0} dataType='number' cellRender={TimeBoxBold} editCellComponent={EditCellTimeComponent} hidingPriority={1} />
                    <Column dataField="roundtime" caption='Rundenzeit' dataType='number' cellRender={TimeBoxBold} editCellComponent={EditCellTimeComponent} allowEditing={false} hidingPriority={3} />
                    <Column dataField="athleteId" caption='Sportler' hidingPriority={4}>
                        <Lookup dataSource={athleteStore} valueExpr="athleteId" displayExpr={(item) => `${item.lastname}, ${item.surname}`} />
                    </Column>

                </DataGrid>
            </div>

            <div className='right'>
                <div className='dx-card details-card'>
                    <DataGrid dataSource={resultRankStore} showBorders={true} remoteOperations={true}>
                        <Editing allowUpdating={checkPermission("result.edit")} allowAdding={false} allowDeleting={checkPermission("result.edit")} />
                        <Column dataField="rank" caption='Platzierung' calculateDisplayValue={function (e) { return (e.rank + " von " + e.totalRank) }} />
                        <Column dataField="description" caption='Beschreibung ' />

                    </DataGrid>
                </div>
            </div>
        </div>

    );
};
